module.exports = __webpack_public_path__ + "3a0476a8a0c4c38075d761e069ec4648.png";